export function getApiErrorMessage (source, fallback = '系統繁忙，請稍後再試') {
  const data = source?.response?.data || source?.data || source
  const error = data?.error

  if (Array.isArray(error)) {
    return error.filter(Boolean).join('\n') || fallback
  }
  if (typeof error === 'string' && error.trim()) {
    return error
  }

  if (Array.isArray(data?.list)) {
    const listMessage = data.list
      .map(item => item?.message)
      .filter(Boolean)
      .join('\n')
    if (listMessage) {
      return listMessage
    }
  }

  if (data instanceof Error) {
    return fallback
  }

  return data?.message || data?.name || fallback
}
